@import '~less/bootstrap/legacy-mixins';
@import '~less/global-variables';

.avatar {
  display: inline-block;
  border-radius: @border-radius-base;
  background-color: @gray-lighter;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(~img/avatar.png);
  // Stop alt-texts overflowing
  overflow: hidden;

  &.avatar-gravatar {
    // Image informs users if they are blocking access to Gravatar.com
    background-image: url(~img/avatar-gravatar.png);
    background-size: contain;
  }

  &.avatar-2048 {
    .square(2048px);
  }
  &.avatar-1024 {
    .square(1024px);
  }
  &.avatar-512 {
    .square(512px);
  }
  &.avatar-256 {
    .square(256px);
  }
  &.avatar-128 {
    .square(128px);
  }
  &.avatar-64 {
    .square(64px);
  }
  &.avatar-36 {
    .square(36px);
  }
  &.avatar-32 {
    .square(32px);
  }
  &.avatar-24 {
    .square(24px);
  }
  &.avatar-16 {
    .square(16px);
  }
}

img.avatar-circle,
.avatar-circle img {
  border-radius: 50%;
  overflow: hidden;
}
